export default __webpack_public_path__ + "static/media/output.367f365d.mp3";